import { useDataFetch } from './Use-data-fetch';

/**
 * Top de redes más activas del último corte de regalías, ordenadas por puntos.
 *
 * El top lo arma el backend con una aggregation: un corte tiene una fila por
 * distribuidor con los ids de todas las órdenes de todos sus niveles, así que
 * traerlo entero al navegador para ordenar diez filas no escala.
 */
export const useTopNetworks = ({
  settlementId,
  currency,
  limit = 10,
  type = 'LOYALTY_ROYALTY',
  province,
  city
} = {}) => {
  const { getData } = useDataFetch();

  const { data, isLoading, error } = getData(
    ['top-networks', settlementId, currency, limit, type, province, city],
    '/settlements/top-networks',
    {},
    {
      settlement_id: settlementId || undefined,
      currency: currency || undefined,
      limit,
      type,
      province,
      city
    }
  );

  return {
    networks: data?.data?.networks ?? [],
    settlement: data?.data?.settlement ?? null,
    isLoading,
    error,
  };
};
